import React from 'react'
import { Trans } from 'react-i18next'

import Customer from '@services/Customer'

interface CustomerMigrationsBlockProps {
  consultationMigrated: boolean
  userHash: string
  markAsMigrated: (result: boolean) => void
}

async function migrateUserConsultations({
  userHash,
  markAsMigrated,
}: Omit<CustomerMigrationsBlockProps, 'consultationMigrated'>) {
  try {
    await Customer.migrateConsultations.store({
      hash: userHash,
    })
    markAsMigrated(true)
  } catch (error) {
    console.error('❌ ~ migrateUserConsultations:', error)
  }
}

export function CustomerMigrationsBlock({
  consultationMigrated,
  userHash,
  markAsMigrated,
}: CustomerMigrationsBlockProps) {
  const [isLoading, setIsLoading] = React.useState(false)

  const onClick = async () => {
    setIsLoading(true)
    try {
      await migrateUserConsultations({ userHash, markAsMigrated })
    } catch (error) {}
    setIsLoading(false)
  }

  return (
    <>
      <h1 className="title-label">
        <Trans>Migraciones</Trans>
      </h1>
      <div className="block">
        <div className="block_row">
          <div className="form-group grid-element ">
            <label className="form-label" style={{ width: '100%', marginBottom: '12px' }}>
              <Trans>Consultas</Trans>
            </label>
            {consultationMigrated ? (
              <span>
                <Trans>Las consultas de este usuario ya han sido migradas</Trans>
              </span>
            ) : (
              /* button outline bootstrap */
              <button
                className="btn btn-outline-primary"
                type="button"
                style={{ width: '100%' }}
                onClick={onClick}
                disabled={isLoading}
              >
                <Trans>Migrar Consultas</Trans>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
